// extracted by mini-css-extract-plugin
export var container = "_am-0";